import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AppShowcase } from './components/AppShowcase';
import { WhatYouFind } from './components/WhatYouFind';
import { TakeawaysSection } from './components/TakeawaysSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-full bg-cream font-sans antialiased" data-id="element-0" data-mp="2wiyx2s8zrtbo">
      <noscript data-id="element-1" data-mp="28u5zysgmvffh">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="28tmdcyg1g2v4" />
      </noscript>
      <Header data-id="element-3" data-mp="3ij61k21ff746" />
      <main data-id="element-4" data-mp="3ijpe138b53at">
        <Hero data-id="element-5" data-mp="3ii4su47vuwpm" />
        <AppShowcase data-id="element-6" data-mp="3mlj6wpc9h30f" />
        <WhatYouFind data-id="element-7" data-mp="3mkre1ma1tjdu" />
        <TakeawaysSection data-id="element-8" data-mp="3mk84asujy1aw" />
        <PricingSection data-id="element-9" data-mp="3mjg7xft4rzjk" />
        <GuaranteeSection data-id="element-10" data-mp="3rcj6y3gog175" />
        <FaqSection data-id="element-11" data-mp="3rdaquh0wwahl" />
        <ClosingSection data-id="element-12" data-mp="3rcsw5otwe4bs" />
      </main>
      <Footer data-id="element-13" data-mp="5yj0slx59ec" />
    </div>;
}